import React from 'react';
import LazyLoad from 'react-lazyload';
// import { browserHistory } from 'react-router';
// import __isEmpty from 'lodash/isEmpty';
import { Curious } from '@curi/react';

import './GirlScoutsWrapper.css';

import Button from '../../components/elements/Button';
import FAQTable from '../../components/global/FAQTable';
import Video from '../../components/global/Video';
import { gtmPageviewEvent } from '../../services/google-tag-manager';
let faqItems = require('./girlscouts-faq.json');
const imgURL = process.env.REACT_APP_CLOUDFRONT_URL;

class GirlScouts extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      faq: null,
    }
  }

  componentDidMount() {

    faqItems = JSON.stringify(faqItems);
    faqItems = faqItems.replace(/REACT_APP_ACCOUNTS_BASE_URL/g, process.env.REACT_APP_ACCOUNTS_BASE_URL);
    console.log('process.env.REACT_APP_ACCOUNTS_BASE_URL', process.env.REACT_APP_ACCOUNTS_BASE_URL);
    faqItems = JSON.parse(faqItems);
    console.log('faqItems', faqItems);
    this.setState({ faq: faqItems });

    gtmPageviewEvent({
      pageName: 'WebPaymentsV2 Page: Coding for Girl Scouts',
      componentProps: this.props,
    });
  }

  // get started link for parents
  getStarted() {
    window.open(process.env.REACT_APP_ACCOUNTS_BASE_URL + '/girl-scouts-parents', '_self');
  }

  // council request
  councilGetStarted() {
    window.open(process.env.REACT_APP_ACCOUNTS_BASE_URL + '/girl-scouts-councils-request', '_self');
  }

  render() {
    return (
      <div className="page gs-bp-wrapper-container">
        {/*<LoadingBar className="global-loading-bar" />*/}

        {/* page title */}
        <div className="grid-x grid-padding-x gs-bp-container">
          <div className="small-12 cell gs-bp-title">
            <h1>Girl Scouts, Let's Code!</h1>
            <p>We've partnered with Girl Scouts of the USA to encourage more girls to code and get a head start in computer science. <a href='#learn-more'>Learn More</a></p>
          </div>
        </div>

        {/* parents and volunteers */}
        <div className="grid-x grid-margin-x parents-volunteers">


          <div className="small-2 cell show-for-medium foo-img-div">
            <img className="foo-img" alt="" src={`${imgURL}/global/naomi-hachi-sm.png`} aria-hidden="true" />
          </div>

          <div className="small-12 medium-4 cell rounded-rect-bg">
            <p className="heading"><b>Girl Scout Councils and Service Units</b></p>
            <p>Host a free one-day coding event with codeSpark.</p>
            <Button id="girl-scouts-councils-request" extraClass="alt-blue" text="LEARN MORE" type="in-page" onClick={() => { this.councilGetStarted(); }} />
          </div>

          <div className="small-12 medium-6 cell rounded-rect-bg">
            <p className="heading"><b>Girl Scout Caregivers and Volunteers</b></p>
            <p>Get codeSpark 51% off annual licenses for home and troop use.</p>
            <Button id="girl-scouts-parents" extraClass="buy-licenses-btn" text="GET STARTED" type="in-page" onClick={() => { this.getStarted(); }} />
          </div>

        </div>

        {/*
        moved to the faq -- you can make changes and test them here and then com press it and paste into the json\
        */}
        {/*
        <div className="show-for-small-only">
          <div className="grid-x grid-margin-x align-center badge-list-small">
            <div className="small-12"><b>Daisies</b></div>
            <div className="small-12"><img src="https://thefoos-com.s3-us-west-2.amazonaws.com/global/girl-scouts/badges/19_GE_DaisyCodingBasics_badge_300x300px.png"/></div>
            <div className="small-12"><p>Coding Basics</p></div>
            <div className="small-12"><img src="https://thefoos-com.s3-us-west-2.amazonaws.com/global/girl-scouts/badges/19_GE_DaisyDigitalGameDesign_badge_300x300px.png"/></div>
            <div className="small-12"><p>Digital Game Design</p></div>
            <div className="small-12"><img src="https://thefoos-com.s3-us-west-2.amazonaws.com/global/girl-scouts/badges/19_GE_DaisyAppDevelopment_badge_300x300px.png"/></div>
            <div className="small-12"><p>App Development</p></div>

            <div className="small-12"><b>Brownies</b></div>
            <div className="small-12"><img src="https://thefoos-com.s3-us-west-2.amazonaws.com/global/girl-scouts/badges/19_GE_BrownieCodingBasics_badge_300x300px.png"/></div>
            <div className="small-12"><p>Coding Basics</p></div>
            <div className="small-12"><img src="https://thefoos-com.s3-us-west-2.amazonaws.com/global/girl-scouts/badges/19_GE_BrownieDigitalGameDesign_badge_300x300px.png"/></div>
            <div className="small-12"><p>Digital Game Design</p></div>
            <div className="small-12"><img src="https://thefoos-com.s3-us-west-2.amazonaws.com/global/girl-scouts/badges/19_GE_BrownieAppDevelopment_badge_300x300px.png"/></div>
            <div className="small-12"><p>App Development</p></div>

            <div className="small-12"><b>Juniors</b></div>
            <div className="small-12"><img src="https://thefoos-com.s3-us-west-2.amazonaws.com/global/girl-scouts/badges/19_GE_JuniorCodingBasics_Badge_300x300px.png"/></div>
            <div className="small-12"><p>Coding Basics</p></div>
            <div className="small-12"><img src="https://thefoos-com.s3-us-west-2.amazonaws.com/global/girl-scouts/badges/19_GE_JuniorDigitalGameDesign_badge_300x300px.png"/></div>
            <div className="small-12"><p>Digital Game Design</p></div>
            <div className="small-12"><img src="https://thefoos-com.s3-us-west-2.amazonaws.com/global/girl-scouts/badges/19_GE_JuniorAppDevelopment_badge_300x300px.png"/></div>
            <div className="small-12"><p>App Development</p></div>
          </div>
        </div>
        */}
        {/*callouts*/}
        <div className="grid-x grid-margin-x">
          <div className="small-12 medium-6 cell balloon-quote">
            <p>"A fantastic problem solving App. My 5-year old is hooked"</p>
            <p>--Vivienne A., codeSpark Parent</p>
          </div>
          <div className="small-12 medium-6 cell balloon-quote">
            <p>"The Foos are funny, cute and I love them!"</p>
            <p>--Nicole, Age 7, codeSpark User</p>
          </div>
        </div>

        {/* welcome girl scouts */}
        <div className="grid-x grid-padding-x gs-welcome-container">
          <div className="small-12 medium-6 cell">
          <LazyLoad height={480} once={true} offset={100}>
            <div className="small-12 medium-7 cell trailer">
              <Video
                videoUrl="https://d2bqrn11jthp5j.cloudfront.net/global/video/codeSparkOnboard720p.mp4"
                title="Peek Inside demo"
                poster={`${imgURL}/global/homepage-video-thumbnail.jpg`}>
                Your browser does not support the video tag.
              </Video>
            </div>
          </LazyLoad>
          </div>
          <div className="small-12 medium-6 cell">
            <div>
              <h2>Welcome, Girl Scouts!</h2>
              <p>Start now and code your own interactive games and stories!</p>
            </div>

          </div>
        </div>

        {/* why girl scouts */}
        <div id= "learn-more" className="grid-x grid-padding-x gs-about-container">
          <div className="small-12 cell">
            <h2>WHY GIRL SCOUTS AND CODESPARK?</h2>
            <p>Girl Scouts of the USA & codeSpark join forces!</p>
            <p>codeSpark empowers kids to be digital creators. Our award winning computer platform was designed with girls in mind and 53% of our users are girls.</p>
            <p>Girl Scouts of the USA (GSUSA) is 2.5 million strong—more than 1.7 million girls and 750,000 adults who believe in the power of every <a href="https://www.girlscouts.org/en/about-girl-scouts/like-a-girl-scout.html" target="_blank" rel="noopener noreferrer">G.I.R.L. (Go-getter, Innovator, Risk-taker, Leader)™</a> to change the world. codeSpark is delighted to have curated and created activities for the Girl Scout Coding for Good Badges. <a href="https://www.girlscouts.org" target="_blank" rel="noopener noreferrer">Volunteer, reconnect, donate, or join.</a></p>
            <p>The Coding for Good badges teach girls the basics of coding and also detail how every stage of the coding process has opportunities for girls to use their skills for good. Every Coding for Good badge has a plugged-in and unplugged version, so all girls will be able to learn the foundations of coding, regardless of their access to technology.</p>
            <p>Research shows that coding is best learned through a combination of screen based and unplugged activities focused on creating with code. The Coding for Good badges allow girls to learn key 21st century skills that support better problem solving and critical thinking.</p>
          </div>
        </div>

        {/* faq */}
        <div className="grid-x grid-padding-x gs-faq-container">
          <FAQTable rowItems={faqItems} />
        </div>
      </div >
    );
  }
}

export default props => (
  <Curious>
    {({ router, response, navigation }) => {
      return <GirlScouts router={router} response={response} {...props} />;
    }}
  </Curious>
);



// WEBPACK FOOTER //
// ./src/containers/GirlScouts/index.js